<template>
  <div class="general-layout">
    <div v-if="$scopedSlots.header" class="header">
      <slot name="header" />
    </div>
    <div class="body" :style="bodyStyle">
      <div v-if="$scopedSlots.left" class="left" :style="leftStyle">
        <slot name="left" />
      </div>
      <div v-if="resizable" v-resize="'x'"></div>
      <div v-if="$scopedSlots.right" class="right" :class="{ clean }">
        <slot name="right" />
      </div>
    </div>
    <div v-if="$scopedSlots.footer" class="footer">
      <slot name="footer" />
    </div>
    <slot name="default" />
  </div>
</template>

<script>
export default {
  name: 'GeneralLayout',
  props: {
    leftStyle: {
      type: Object,
      default: () => ({})
    },
    bodyStyle: {
      type: Object,
      default: () => ({}),
    },
    clean: {
      type: Boolean,
      default: false,
    },
    resizable: {
      type: Boolean,
      default: true
    }
  },
}
</script>

<style lang="less" scoped>
.general-layout {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  .header {
    margin-bottom: 8px;
  }
  .body {
    display: flex;
    // height: calc(100% - 56px);
    height: 100%;
    overflow-y: auto;
    .left {
      flex: none;
      width: 320px;
      height: 100%;
      background-color: #fff;
      // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      border: 1px solid #d8d8d8;
      border-radius: 2px;
      overflow: auto;
    }
    .right {
      position: relative;
      width: 100%;
      height: 100%;
      background-color: #fff;
      // overflow-x: hidden;
      // overflow-y: auto;
      overflow: auto;
      overflow-x: hidden;
      // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      border: 1px solid #d8d8d8;
      border-radius: 2px;
    }
    .clean {
      background-color: transparent;
      box-shadow: none;
      border-radius: 0;
    }
  }
  .footer {
    margin-top: 16px;
  }
}
</style>
